const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const activateVideo = (video) => {
  if (video.dataset.crsLazyVideoLoaded === 'true') return;

  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });

  video.dataset.crsLazyVideoLoaded = 'true';
  video.load();
};

const playWhenAllowed = (video) => {
  if (video.dataset.crsAutoplay !== 'true' || reducedMotion.matches) return;
  video.play().catch(() => {});
};

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        activateVideo(video);
        playWhenAllowed(video);
      } else if (video.dataset.crsAutoplay === 'true') {
        video.pause();
      }
    });
  },
  { rootMargin: '360px 0px', threshold: 0.01 }
);

const observeLazyVideos = (root = document) => {
  root.querySelectorAll('video[data-crs-lazy-video]').forEach((video) => {
    if (video.dataset.crsLazyVideoObserved === 'true') return;
    video.dataset.crsLazyVideoObserved = 'true';

    if (video.dataset.crsHeroVideo === 'true') {
      const loadHeroVideo = () => {
        const start = () => {
          activateVideo(video);
          playWhenAllowed(video);
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(start, { timeout: 1500 });
        } else {
          window.setTimeout(start, 750);
        }
      };

      if (document.readyState === 'complete') {
        loadHeroVideo();
      } else {
        window.addEventListener('load', loadHeroVideo, { once: true });
      }
      return;
    }

    observer.observe(video);
  });
};

observeLazyVideos();

document.addEventListener('shopify:section:load', (event) => {
  observeLazyVideos(event.target);
});
